import React, {useState} from "react"
import {KeyEvent} from "../../../dtos/eventResponse"
import KeyEventsStatistics from "./KeyEventsStatistics"
import EventAccordionDetails from "./EventAccordionDetails"
import {getUpdatesCount, getWarningsCount} from "../../../services/order/eventHelper"
import {Button, Collapse, Grid, IconButton, Typography} from "@mui/material"
import {makeStyles} from "tss-react/mui"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

interface OrderEventAccordionProps {
	orderNumber: string
	orderEvents: KeyEvent[]
	expandedPanel: string | boolean
	updateExpandedPanel: (expanded: string) => void
}
const useStyles = makeStyles()({
	expandButton: {
		fontSize: "13px",
		fontStyle: "normal",
		fontWeight: 500,
		lineHeight: "22px",
		letterSpacing: "0.46px",
		textTransform: "uppercase",
		pointerEvents: "auto",
	},
	summary: {
		pointerEvents: "none",
	},
	expandOpen: {
		transform: "rotate(180deg)",
	},
	text: {
		color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
		fontSize: "12px",
		fontStyle: "normal",
		fontWeight: 400,
		lineHeight: "100%",
	},
	title: {
		color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
		fontFeatureSettings: "'liga' off, 'clig' off",
		fontSize: "16px",
		fontStyle: "normal",
		fontWeight: 500,
		lineHeight: "175%",
		letterSpacing: "0.15px",
	},
	details: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "4px",
		padding: "0px 8px",
		justifyContent: "center",
		alignSelf: "stretch",
		width: "380px",
		height: "104px",
	},
})

export default function OrderEventAccordion(props: OrderEventAccordionProps) {
	const {classes} = useStyles()
	const [expanded, setExpanded] = useState<boolean>(props.expandedPanel === props.orderNumber)
	const onClickExpandButton = () => {
		setExpanded(!expanded)
		if (expanded === true) {
			props.updateExpandedPanel(props.orderNumber)
		}
	}
	return (
		<div
			style={{
				borderRadius: "4px",
				border: "1px solid var(--divider, rgba(0, 0, 0, 0.12))",
				width: "100%",
			}}
		>
			<Grid
				container
				spacing={2}
				justifyContent="space-between"
				alignItems="center"
				style={{padding: "0px 8px"}}
			>
				<Grid item xs={5}>
					<div className={classes.details}>
						<Typography className={classes.title}>{props.orderNumber}</Typography>
						<Typography className={classes.text}>General events related to the order</Typography>
					</div>
				</Grid>
				<Grid item xs={2} style={{justifyContent: "flex-start"}}>
					<KeyEventsStatistics
						warnings={getWarningsCount(props.orderEvents)}
						updates={getUpdatesCount(props.orderEvents)}
					/>
				</Grid>
				<Grid item xs={5}>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "flex-end",
						}}
					>
						<Button color="primary" className={classes.expandButton} onClick={onClickExpandButton}>
							See all events
							<IconButton
								sx={{
									transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
									marginLeft: "auto",
									transition: (theme) =>
										theme.transitions.create("transform", {
											duration: theme.transitions.duration.shortest,
										}),
								}}
								color="primary"
								onClick={onClickExpandButton}
								aria-expanded={expanded}
								aria-label="Show more"
							>
								<ExpandMoreIcon />
							</IconButton>
						</Button>
					</div>
				</Grid>
			</Grid>
			<Collapse in={expanded} timeout="auto" unmountOnExit>
				<EventAccordionDetails events={props.orderEvents || []} />
			</Collapse>
		</div>
	)
}
